module.exports = __webpack_public_path__ + "static/painting - 2-1ec02cada83e4f8a8875db4e0b449749.jpg";